import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Juan', 'María', 'Lucas', 'Sofía', 'Martín', 'Lucía', 'Federico', 'Valentina', 'Diego', 'Camila'];
const cities = ['Córdoba', 'Rosario', 'Mendoza', 'CABA', 'Mar del Plata', 'Neuquén', 'Bariloche', 'Salta', 'Tucumán', 'La Plata'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setBuyer({
        name: randomName,
        city: randomCity,
        time: `${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-138">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-xl shadow-lg border border-sky-100 p-3 z-50 flex items-start gap-3" data-id="element-139">
          <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center flex-shrink-0" data-id="element-140">
            <span className="text-sky-600 font-bold text-lg" data-id="element-141">
              {buyer.name.charAt(0)}
            </span>
          </div>
          <div className="flex-1" data-id="element-142">
            <p className="text-sm text-slate-800" data-id="element-143">
              <span className="font-bold" data-id="element-144">{buyer.name}</span> de{' '}
              <span className="font-semibold" data-id="element-145">{buyer.city}</span>
            </p>
            <p className="text-xs text-slate-500 mt-0.5" data-id="element-146">
              Acaba de comprar este libro digital
            </p>
            <p className="text-[10px] text-sky-500 mt-1 font-medium flex items-center gap-1" data-id="element-147">
              <MapPin className="w-3 h-3" data-id="element-148" /> Hace {buyer.time}
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-149">
            <X className="w-4 h-4" data-id="element-150" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}